import { useContext, useEffect, useState } from 'react';

import { Formik } from 'formik';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router';
import { Link } from 'react-router-dom';

import { EventContext } from '../../../Contexts/EventContext';
import Loading from '../../../Shared/Components/Loading';
import Pagination from '../../../Shared/Components/Pagination';
import { error } from '../../../Shared/Components/Toast';
import useApi from '../../../Shared/hooks/api/Index';
import { useAccess } from '../../../Shared/hooks/useAccess';
/** @format */
import Master from '../../Layouts/Master';

const User = () => {
  const eventContext = useContext(EventContext);
  const { canManageUsers } = useAccess();
  const navigate = useNavigate();
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [parseParams, setParseParams] = useState({});

  useEffect(() => {
    const params = queryString.parse(search);
    setParseParams(params);
    getUsers();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const getUsers = async () => {
    setLoading(true);
    await useApi.get(
      `/panel/user${search}`,
      {},
      (res) => {
        eventContext.users = res.data;
        setLoading(false);
      },
      () => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };

  const buildFilterQuery = (values) => {
    const regexPaginate = /page=([0-9]+)/;
    const pageExists = regexPaginate.test(search);
    const paginate = parseParams?.page;

    let filter = pageExists ? `?page=${paginate}` : '';

    Object.entries(values).forEach(([key, value]) => {
      if (value && String(value).length > 0) {
        filter +=
          filter.length > 0 ? `&${key}=${value}` : `?${key}=${value}`;
      }
    });

    return filter;
  };

  const userFilter = (values) => {
    navigate(`/panel/admin/users${buildFilterQuery(values)}`);
  };

  const clearFilter = (resetForm) => {
    resetForm({
      values: {
        name: '',
        last_name: '',
        national_card_id: '',
      },
    });
    navigate('/panel/admin/users');
  };

  const hasActiveFilter =
    parseParams?.name ||
    parseParams?.last_name ||
    parseParams?.national_card_id;

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-users f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست کاربران
          </h1>
        </div>
      </div>

      <div className='card border rounded shadow-sm mb-3'>
        <div className='card-body py-3 px-3'>
          <div className='d-flex flex-row align-items-center mb-3 pb-2 border-bottom'>
            <i className='fad fa-filter f-16 text-info ml-2'></i>
            <span className='f-13 font-weight-bold text-secondary mb-0'>
              جستجو و فیلتر کاربران
            </span>
            {hasActiveFilter && (
              <span className='badge badge-info mr-2 f-11'>فیلتر فعال</span>
            )}
          </div>
          <Formik
            enableReinitialize
            initialValues={{
              name: parseParams?.name ?? '',
              last_name: parseParams?.last_name ?? '',
              national_card_id: parseParams?.national_card_id ?? '',
            }}
            onSubmit={(values) => userFilter(values)}
          >
            {({ values, handleChange, handleSubmit, resetForm }) => (
              <form onSubmit={handleSubmit}>
                <div className='row align-items-end'>
                  <div className='col-12 col-md-3'>
                    <div className='form-group mb-md-0'>
                      <label className='f-12 text-secondary mb-1'>نام</label>
                      <input
                        className='form-control f-13'
                        type='text'
                        name='name'
                        value={values.name}
                        onChange={handleChange}
                        placeholder='نام کاربر'
                      />
                    </div>
                  </div>
                  <div className='col-12 col-md-3'>
                    <div className='form-group mb-md-0'>
                      <label className='f-12 text-secondary mb-1'>
                        نام خانوادگی
                      </label>
                      <input
                        className='form-control f-13'
                        type='text'
                        name='last_name'
                        value={values.last_name}
                        onChange={handleChange}
                        placeholder='نام خانوادگی'
                      />
                    </div>
                  </div>
                  <div className='col-12 col-md-3'>
                    <div className='form-group mb-md-0'>
                      <label className='f-12 text-secondary mb-1'>کد ملی</label>
                      <input
                        className='form-control f-13'
                        type='text'
                        name='national_card_id'
                        value={values.national_card_id}
                        onChange={handleChange}
                        placeholder='کد ملی ۱۰ رقمی'
                        maxLength={10}
                      />
                    </div>
                  </div>
                  <div className='col-12 col-md-3'>
                    <div className='d-flex flex-row justify-content-md-end mt-3 mt-md-0'>
                      <button
                        type='button'
                        className='btn btn-outline-secondary f-13 mx-1'
                        onClick={() => clearFilter(resetForm)}
                      >
                        <i className='fad fa-times ml-1'></i>
                        پاک کردن
                      </button>
                      <button type='submit' className='btn btn-info f-13'>
                        <i className='fad fa-search ml-1'></i>
                        جستجو
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>

      <div className='w-100 overflow-auto'>
        {eventContext.users?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>نام</th>
                <th>نام خانوادگی</th>
                <th>کد ملی</th>
                <th>شماره همراه</th>
                <th>نقش</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {eventContext.users?.data?.map((item, index) => (
                <tr key={item.id}>
                  <th>
                    {(eventContext.users.meta.pagination.current_page - 1) *
                      eventContext.users.meta.pagination.count +
                      (index + 1)}
                  </th>

                  <td>{item?.name}</td>
                  <td>{item?.last_name}</td>

                  <td>{item?.national_card_id ?? '-'}</td>
                  <td>{item?.mobile ?? '-'}</td>
                  <td>
                    {item.roles?.map((role) => (
                      <span key={role.id} className='text-secondary f-12'>
                        {role.description}{' '}
                        {item.roles[item.roles.length - 1]?.id !== role.id
                          ? ','
                          : ''}{' '}
                      </span>
                    ))}
                  </td>
                  <td>
                    <Link
                      to={`/panel/admin/users/edit/${item.id}`}
                      className='btn btn-warning f-13 mx-1'
                    >
                      ویرایش
                    </Link>
                    {canManageUsers() && (
                      <Link
                        to={`/panel/admin/users/set-roles/${item.id}`}
                        className='btn btn-info f-13'
                      >
                        دسترسی
                      </Link>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border rounded p-4 my-3 bg-light'>
            <span className='f-13 font-weight-bold text-secondary'>
              {hasActiveFilter
                ? 'کاربری با این مشخصات یافت نشد'
                : 'کاربری ثبت نام نکرده است'}
            </span>
          </div>
        )}
      </div>
      <Pagination
        totalPage={eventContext.users?.meta?.pagination?.total_pages}
        basePath='/panel/admin/users'
      />
    </Master>
  );
};

export default User;
